/**
 * 表紙特集掲載商品選定（バイヤー）画面の商品部への選定依頼一覧クラス
 *
 * @export ReplacementListInfo
 * @class ReplacementListInfo
 */
export class ReplacementListInfo {
  constructor(
    // 依頼先バイヤー
    public requestBuyer: string = null,
    // 担当
    public person: string = null,
    // バイヤー選定依頼ID
    public buyerRequestId: string = null,
    // 特集コード
    public featureCode: string = null,
    // 特集名
    public featureName: string = null,
    // フォーマット特集
    public formatFeature: string = null,
    // 部門コード
    public classCode: string = null,
    // 部門名
    public classNameKanji: string = null,
    // フォーマット部門
    public formatClass: string = null,
    // 中分類コード
    public middleClassCode: string = null,
    // 中分類名
    public middleClassNameKanji: string = null,
    // フォーマット中分類
    public formatMiddleClass: string = null,
    // Pコード
    public pCode: string = null,
    // アイテムコード
    public itemCode: string = null,
    // 商品名(商品案内用商品名)
    public guideGoodsName: string = null,
    // 規格名(商品案内用規格名)
    public guideStandardName: string = null,
    // 価格パターン
    public pricePattern: string = null,
    // 今回供給価格
    public thisTimeSupplyPrice: string = null,
    // 仕入価(今回仕入価格)
    public thisTimeCostPrice: string = null,
    // 計画数(予測)
    public predictPlanNum: string = null,
    // 計画数
    public planNum: string = null,
    // 計画供給高
    public planSupplyBudget: string = null,
    // 表示用：計画供給高（千円）
    public dispPlanSupplyBudget: string = null,
    // GPR
    public gpr: string = null,
    // 依頼ステータス
    public requestStatus: string = null,
    // 備考
    public remarks: string = null,
  ) {}
}
